import { createApp } from 'vue'
import App from './App.vue'
import { pinia } from './store'
import 'element-plus/dist/index.css'
import './app.css'
import router from './config/routes'
import { initMainRouter } from './router/index'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import ElementPlus from 'element-plus'
import print from 'vue3-print-nb'
import '@/assets/font-icon/iconfont.js';
import vconsole from 'vconsole'

// import.meta.env.MODE == 'development' && new vconsole()

const init = async () => {

    await initMainRouter()
    const app = createApp(App)
    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
        app.component(key, component)
    }

    app.use(ElementPlus)
    app.use(print)
    app.use(pinia)
    app.use(router)
    // app.use(vConsole)

    app.mount('#app')
}

init()
